// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__K8Fva","label":"LanguagePicker_label__tCTAY","icon":"LanguagePicker_icon__hEGhl"};